import { simpleSet } from '@r/reducers/utils';

const s = simpleSet as redux.reducers.assetsLoaded;

export const assetsLoaded = s( 'SET_ASSETS_LOADED', false );
